var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 167,
    viewBox: "0 0 160 167",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 105"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7162 95.8636V52.3136C15.7162 46.7533 15.7162 41.953 15.8463 37.7838C7.23168 43.4927 2.40043 48.2985 0.658065 54.7876C-2.0724 64.9567 3.83788 75.3307 15.7162 95.8636ZM64.8951 9.17302H100.615C102.776 9.17302 104.822 9.17302 106.762 9.18043C102.944 4.64334 99.1969 1.88317 94.6101 0.656702C86.5069 -1.51006 78.2737 1.77576 64.8951 9.17302ZM144.074 71.1054V114.686C144.074 120.252 144.074 125.056 143.944 129.228C152.57 123.514 157.407 118.706 159.151 112.212C161.882 102.038 155.965 91.6588 144.074 71.1054ZM94.9135 157.827H59.1753C57.0217 157.827 54.9812 157.827 53.0466 157.82C56.8643 162.357 60.6118 165.117 65.1985 166.343C73.3018 168.51 81.5349 165.224 94.9135 157.827Z",
    fill: "#C3D9D9",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.1152 53.3191C18.1152 33.6379 18.1152 23.7974 24.2421 17.6832C30.3689 11.5691 40.2299 11.5691 59.9519 11.5691H99.845C119.567 11.5691 129.428 11.5691 135.555 17.6832C141.682 23.7974 141.682 33.6379 141.682 53.3191V113.681C141.682 133.362 141.682 143.203 135.555 149.317C129.428 155.431 119.567 155.431 99.845 155.431H59.952C40.2299 155.431 30.3689 155.431 24.2421 149.317C18.1152 143.203 18.1152 133.362 18.1152 113.681V53.3191Z",
    fill: "#C3D9D9",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Vector_2",
    cx: 110.799,
    cy: 42.3968,
    rx: 10.2972,
    ry: 10.2759,
    fill: "#00A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    opacity: 0.8,
    d: "M69.6136 155.431H90.208C114.479 155.431 126.614 155.431 134.154 147.906C138.751 143.319 140.545 137.026 141.246 127.323C128.478 109.903 121.301 101.192 111.721 101.192C101.234 101.192 93.6264 111.632 78.4106 132.51L61.7148 155.419C64.1951 155.431 66.8242 155.431 69.6136 155.431Z",
    fill: "#00A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M69.6079 155.431H90.2023C101.736 155.431 110.529 155.431 117.39 154.624L97.3454 126.619C78.2466 99.936 68.6973 86.5946 55.4495 86.5946C43.3316 86.5946 34.3081 97.7573 18.2402 120.083C18.5945 134.048 20.0095 142.266 25.6619 147.907C33.2018 155.431 45.3372 155.431 69.6079 155.431Z",
    fill: "#00A6A6"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.f25d38fc471ca982186ae54e65852498.svg";
export { ForwardRef as ReactComponent };